import React, { useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';

import { useAuthenticatedState } from 'src/authenticated-state/context';
import Responsive from 'src/components/responsive';
import ButtonLink from 'src/components/button-link';
import { isFacebookIntegrationNotification } from 'src/services/api/notifications';
import { usePersistentState } from 'src/services/storage/use-persistent-state';

import styles from 'src/components/layout/landlord/FacebookIntegrationAlert.module.css';

export default function FacebookIntegrationAlert() {
    const { pathname } = useLocation();
    const { notifications } = useAuthenticatedState();
    const [isDismissed, setIsDismissed] = usePersistentState('facebookIntegrationAlertDismissed', false);

    const handleDismiss = useCallback(() => {
        setIsDismissed(true);
    }, [setIsDismissed]);

    if (
        pathname.startsWith('/landlord/inner/messages/from-lead') ||
        pathname.startsWith('/landlord/inner/playbooks')
    ) {
        return null;
    }

    const facebookIntegrationNotifications = notifications
        .filter(isFacebookIntegrationNotification)
        .filter((notification) => !notification.is_read_by_user);

    if (facebookIntegrationNotifications.length === 0 || isDismissed) {
        return null;
    }

    const integration = facebookIntegrationNotifications[0];

    const isSettingsPage = pathname.startsWith('/landlord/inner/settings');

    return (
        <Responsive desktop>
            <Alert severity="error" className={styles.alert}>
                <div className={styles.row}>
                    <div className={styles.content}>
                        <span className={styles.title}>Facebook Integration Error</span>
                        {!!integration.is_informational && (
                            <span className={styles.body}>{integration.text}</span>
                        )}
                        {!integration.is_informational && (
                            <span className={styles.body}>
                                There was an error with your Facebook integration.
                                {isSettingsPage ? ' Scroll down to the Facebook section to re-connect.' : ' Please review your settings.'}
                            </span>
                        )}
                    </div>

                    <div className={styles.actions}>
                        {!integration.is_informational && !isSettingsPage && (
                            <ButtonLink variant="contained" color="primary" href="/landlord/inner/settings?tab=lead_ingestion">
                                Fix Issue
                            </ButtonLink>
                        )}
                        <Button variant="text" color="inherit" onClick={handleDismiss}>
                            Dismiss
                        </Button>
                    </div>
                </div>
            </Alert>
        </Responsive>
    );
}
